import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';




export default class IntroPopup extends React.Component {


   constructor(props) {
       super(props);
      this.state = {
        my_key: "popup_"+Math.random()*9999999

      }



      var x = 400
      var y = 400

      var rand = Math.floor(Math.random()*4)

     
          x = Math.random()*1000 + 300
          y = Math.random()*6000 + 300
     
     

      this.randomX = Math.round(Math.random()*0-0);
      this.randomY = Math.round(Math.random()*150-75);
      this.randomZ = Math.round(Math.random()*1-10);
    
      this.state = {

        translateZ: 100,
        translateY: Math.round(y),
        translateX: Math.round(x),
        zIndex: 1000,

        position: 0,
        showing: true
        
        
      };
    }


    componentWillUnmount() {
        clearInterval(this.interval);
      }


  componentDidMount() {

     
        

        this.interval = setInterval(() => {
           

           let speed = Math.random()*1 + 10

           this.setState({
              
              translateX: Math.round((-280 + window.innerWidth / 2 + this.state.translateX * speed + this.state.position * -3) / (speed+1)),
              translateY: Math.round((this.state.translateY * speed + this.state.position * 100) / (speed+1)),
              translateZ: Math.round(0),
              zIndex: Math.round(this.state.translateZ / 1000) + 10
            
            })


            

           

        }, 25);



      }


     




  render() {




    //handle the click on one of the buttons
    const handleClick = (e) => {

        this.setState({
          position: 10
        })




        setTimeout(()=> {

          this.props.closeClick()

        }, 200)

    };
    
    if(this.state.showing)
    {

      return (

        <div class="holder">
      
       
          <Jumbotron className={"popup " + this.props.className} style={{zIndex: this.state.zIndex, transform: "translateZ("+(this.randomZ+this.state.translateZ)+"px) translateY("+(this.randomY+this.state.translateY)+"px) translateX("+(this.randomX+this.state.translateX)+"px)"}}>
          
          <Button value="1" onMouseDown={handleClick} className="intro_x" variant="success" size="lg">X</Button> 
          
        
          {this.props.children}</Jumbotron>
  
  
          {this.props.extras}
          
        
        </div>
  
      );

    }
    else
    {
      return <p></p>
    }
    
  }
}
